<template>
  <CountryPage country="thailand" />
</template>